<template>
    <template v-if="loading">
        <loading-component />
    </template>
    <router-view v-else />
</template>
<script setup>
import { ref, watch, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useApp } from '@/store/app.js'
import '@/utils/axios.js'

// 组件
import LoadingComponent from '@/components/Loading/index.vue'

defineComponent({
    'loading-component': LoadingComponent
})

const route = useRoute()
const app = useApp()
const loading = ref(true)

watch(
    () => route?.query,
    () => {
        if (route?.query?.token) {
            app.setToken(route?.query?.token)
            app.setTenantId(route?.query?.tenantId)
            loading.value = false
        }
    },
    {
        immediate: true
    }
)
</script>
<style lang="less">
@import './assets/css/base.less';
</style>
